export const VIDEOS = {
	'etienne-dupont': '/assets/video/mp4/testimonials/etienne-dupont.mp4',
	'tobias-kern': '/assets/video/mp4/testimonials/tobias-kern.mp4',
	'uliana-avtonomova': '/assets/video/mp4/testimonials/uliana-avtonomova.mp4',
	'emily-johnny-ntg': '/assets/video/mp4/testimonials/emily-johnny-ntg.mp4',
	'lily-waldorf-snowbit': '/assets/video/mp4/testimonials/lily-waldorf.mp4',
	'shai-alani-coralogix': '/assets/video/mp4/testimonials/shai-alani.mp4',
	'anna-kryvytska': '/assets/video/mp4/testimonials/anna-kryvytska.mp4',
	'kateryna-potapova': '/assets/video/mp4/testimonials/kateryna-potapova.mp4',
	'margarita-rybina': '/assets/video/mp4/testimonials/margarita-rybina.mp4',
	'michael-scarpati': '/assets/video/mp4/testimonials/michael-scarpati.mp4'
};
